import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { ROUTES } from '../Routes';
import { usePageTitle } from "../hooks/usePageTitle";

const TermsPage = () => {
    usePageTitle('House Terms');

    return (
        <div className="wp-singular page-template-default page page-id-6 wp-theme-ppc2">
            <Navigation />
            <main id="main">
                <div className="container">

                    <section className="hero" style={{ marginTop: '1.4rem' }}>
                        <div className="kicker">HOUSE COVENANT • ACCESS &amp; CONDUCT</div>

                        <h1 className="hero-title">
                            House Terms &amp; Conditions
                        </h1>

                        <p className="hero-lead">
                            These terms govern access to the manor 🕯. The experience is social and virtual-only:
                            no deposits, no withdrawals, and no cash value.
                        </p>
                    </section>

                    <section className="content-section terms-section">
                        <h2>Agreement</h2>

                        <div className="panel panel--glass" style={{ marginTop: '1.1rem' }}>
                            <p className="page-copy">
                                By accessing Torox Games, you agree to these terms. The platform is owned and
                                operated by SF2 SIA (Latvia). If you do not accept the terms, you must not use the service.
                            </p>
                        </div>

                        <div className="terms-stack">
                            <div className="panel panel--glass terms-panel">
                                <h3 className="section-h3">1) VIRTUAL-ONLY PLAY</h3>
                                <ul className="notice-list">
                                    <li>All play uses virtual Credits only.</li>
                                    <li>No deposits, purchases, or withdrawals are available.</li>
                                    <li>Credits have no real-money value.</li>
                                    <li>Outcomes affect on-site progress and statistics only.</li>
                                </ul>
                            </div>

                            <div className="panel panel--glass terms-panel">
                                <h3 className="section-h3">2) ACCOUNTS &amp; CREDITS</h3>
                                <p className="page-copy">
                                    To use certain features you may need an account. You are responsible for maintaining the
                                    confidentiality of your login details and activity under your account.
                                </p>
                                <ul className="notice-list">
                                    <li>Credits are virtual only and exist within the platform.</li>
                                    <li>Balances appear in your on-site HUD and history.</li>
                                    <li>We may correct or reset balances in cases of abuse.</li>
                                    <li>Credits do not impact real-world finances.</li>
                                </ul>
                            </div>

                            <div className="panel panel--glass terms-panel">
                                <h3 className="section-h3">3) PROHIBITED USE</h3>
                                <p className="page-copy">
                                    You agree not to misuse the service or interfere with its normal operation.
                                </p>
                                <ul className="notice-list">
                                    <li>No bots, scripts, or automated play.</li>
                                    <li>No multi-account farming or manipulation.</li>
                                    <li>No attempts to bypass security or restrictions.</li>
                                    <li>No portrayal of the service as real-money gambling.</li>
                                    <li>No unlawful, abusive, or harmful behavior.</li>
                                </ul>
                            </div>

                            <div className="panel panel--glass terms-panel">
                                <h3 className="section-h3">4) AGE LIMIT</h3>
                                <p className="page-copy">
                                    Entry is restricted to individuals aged 18 years or older. By using the service, you
                                    confirm that you meet this requirement.
                                </p>
                            </div>

                            <div className="panel panel--glass terms-panel">
                                <h3 className="section-h3">5) RESPONSIBLE USE</h3>
                                <p className="page-copy">
                                    This is a virtual-only social experience designed for entertainment. Please play responsibly
                                    and take breaks when needed.
                                </p>
                            </div>

                            <div className="panel panel--glass terms-panel">
                                <h3 className="section-h3">6) LIMITATION OF LIABILITY</h3>
                                <p className="page-copy">
                                    The service is provided “as is” and “as available.” We do not guarantee uninterrupted access
                                    or error-free operation.
                                </p>
                                <p className="page-copy" style={{ marginTop: '.7rem' }}>
                                    To the fullest extent permitted by law, we are not liable for indirect, incidental, or
                                    consequential damages arising from use of the service.
                                </p>
                            </div>

                            <div className="panel panel--glass terms-panel">
                                <h3 className="section-h3">7) UPDATES</h3>
                                <p className="page-copy">
                                    We may update these terms from time to time. Material changes will be posted on this page.
                                </p>
                                <p className="page-copy" style={{ marginTop: '.7rem' }}>
                                    Continued use of the service after updates means you accept the revised terms.
                                </p>
                            </div>

                            <div className="panel panel--glass terms-panel">
                                <h3 className="section-h3">8) CONTACT</h3>
                                <p className="page-copy">
                                    For questions about these terms, contact us at the address below.
                                </p>
                                <p className="page-copy" style={{ marginTop: '.5rem' }}>
                                    <strong>SF2 SIA</strong><br />
                                    Kr. Valdemara iela 33-7<br />
                                    LV-1010 Riga, Latvia<br />
                                    Reg. no 40103691516<br />
                                    Email: support@Torox.site
                                </p>
                            </div>
                        </div>

                        <div style={{ textAlign: 'center', margin: '2.2rem 0 2.8rem' }}>
                            <p className="mini">
                                Effective date: February 22, 2026
                            </p>
                            <Link to={ROUTES.BASE} className="play-btn">
                                BACK TO HOME
                            </Link>
                        </div>
                    </section>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default TermsPage;